<template functional>
  <a
    :href="$options.linkToMobileApp"
    :class="data.staticClass || ''"
    v-bind="data.attrs"
    class="apple-store-badge__download-link"
  >
    <img
      class="apple-store-badge__download-button"
      alt="Apple logo, redirects to the App Store for downloading Bravado application"
      src="./assets/apple-store.svg"
      width="190"
      height="63"
      loading="lazy"
      decoding="async"
    />
  </a>
</template>

<script>
import { LINK_TO_MOBILE_APP as linkToMobileApp } from '@/constants';

export default {
  name: 'AppleStoreBadge',
  linkToMobileApp,
};
</script>

<style lang="scss" scoped>
.apple-store-badge {
  &__download-link {
    display: block;
    text-align: center;
  }

  &__download-button {
    margin-top: 24px;
    width: 194px;
    object-fit: contain;
  }
}
</style>
